import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

@Component({
  selector: 'bil-change-document-alert-box',
  templateUrl: './change-document-alert-box.component.html',
  styleUrls: ['./change-document-alert-box.component.sass']
})
export class ChangeDocumentAlertBoxComponent implements OnInit {
  public isMobile: boolean;
  public showThanksIcon : boolean = false;
  constructor(
    private dialogRef: MatDialogRef<ChangeDocumentAlertBoxComponent>, private breakpointObserver: BreakpointObserver,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    breakpointObserver
      .observe(['(min-width: 600px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isMobile = false;
        } else {
          this.isMobile = true;
        }
      });
  }

  ngOnInit() {
  }

  /**
  * @method onBack
  * @description Back functionality
  * @param void
  * @return void
  */
  onBack() {
    this.dialogRef.close({ event: 'onBack' });
  }

  /**
    * @method onNext
    * @description Next functionality
    * @param void
    * @return void
    */
  onNext() {
    if(this.data['requestForModal']['message'] === 'Credit Card'){
      this.showThanksIcon = true;
      this.data['requestForModal']['subheading'] = 'Thanks for your interest. One of our representatives will contact you shortly.';
        setTimeout (() => {
            this.dialogRef.close({ event: 'onNext' });
      }, 5000)
    } else {
      this.dialogRef.close({ event: 'onNext' });
    }
  }
  onBackClose() {
    this.dialogRef.close();
  }

}
